import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import { ProgressProvider } from "Contexts/ProgressContext";
import { FormDataProvider } from "Contexts/FormDataContext";
import { VisualProvider } from "Contexts/VisualContext";
import { SessionProvider } from "Contexts/SessionContext";
import SessionFormDataSync from "Components/SessionFormDataSync";
import SessionUrlSync from "Components/SessionUrlSync";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SessionProvider>
      <VisualProvider>
        <ProgressProvider>
          <FormDataProvider>
            <SessionFormDataSync>
              <BrowserRouter>
                <SessionUrlSync>
                  <App />
                </SessionUrlSync>
              </BrowserRouter>
            </SessionFormDataSync>
          </FormDataProvider>
        </ProgressProvider>
      </VisualProvider>
    </SessionProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
